import React from "react";
import { SectionHeading } from "@/components/home/SectionHeading";

export const PatchArmSection = () => (
  <section className="bg-[#F8F5EF] py-16 md:py-24" data-testid="patch-arm-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        overline="Where to use it"
        title="Designed For Eczema-Prone Areas"
        subtitle="A soft rectangular patch designed to sit comfortably over common eczema-prone areas, helping protect the skin from scratching and rubbing."
      />
      <div className="rounded-3xl overflow-hidden aspect-[16/9] shadow-[0_8px_40px_rgba(111,80,58,0.08)] max-w-5xl mx-auto">
        <img
          src="/assets/patch-arm.png"
          alt="Baby Hemp patch applied on a child's arm"
          loading="lazy"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  </section>
);
